'use es6';

import AdAccountsData from 'AdsUI/data/AdAccountsData';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import store from 'AdsUI/redux-store';
import fetchWithEarlyRequester from 'AdsUI/lib/fetchWithEarlyRequester';
import { addHeaderBanner } from 'AdsUI/actions/BannerActions';
import AdAccountRecord, { AdAccountStatus } from 'AdsUI/records/ad-accounts/AdAccountRecord';
import BannerTypes from 'AdsUI/lib/BannerTypes';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import PortalIdParser from 'PortalIdParser';

const fetchAdAccountsOverviewSuccess = payload => {
  const accounts = Array.isArray(payload) ? payload : payload.accounts;
  accounts.filter(account => account.status !== AdAccountStatus.ACTIVE && account.status !== AdAccountStatus.UNKNOWN).forEach(inactiveAccount => {
    store.dispatch(addHeaderBanner(BannerTypes.INACTIVE_ACCOUNT, [], {
      adAccount: new AdAccountRecord(inactiveAccount)
    }));
  });
  store.dispatch({
    type: 'AD_ACCOUNTS_OVERVIEW_FETCH_SUCCEEDED',
    payload: accounts
  });
  return accounts;
};

const fetchAdProfileSuccess = payload => {
  const {
    hasConversions
  } = payload;
  usageTracker.setProperties({
    hubId: PortalIdParser.get(),
    email: store.getState().auth.user.email,
    has_conversions: hasConversions
  });
  store.dispatch({
    type: 'AD_PROFILE_FETCH_SUCCEEDED',
    payload
  });
  return payload;
};

export function fetchOverview() {
  return dispatch => {
    return wrapReduxAction(AdAccountsData.fetchOverview, 'AD_ACCOUNTS_OVERVIEW_FETCH', {
      dispatch,
      returnPromise: true,
      success: fetchAdAccountsOverviewSuccess
    });
  };
}
export function fetchOverviewWithEarlyRequester() {
  return dispatch => wrapReduxAction(() => fetchWithEarlyRequester(AdAccountsData.fetchOverview, 'ad-accounts-overview'), 'AD_ACCOUNTS_OVERVIEW_FETCH', {
    dispatch,
    returnPromise: true,
    success: fetchAdAccountsOverviewSuccess
  });
}
export function fetchAdProfile() {
  return dispatch => wrapReduxAction(AdAccountsData.fetchAdProfile, 'AD_PROFILE_FETCH', {
    dispatch,
    success: fetchAdProfileSuccess
  });
}
export function fetchMyPermissions() {
  return dispatch => {
    return wrapReduxAction(AdAccountsData.fetchPermissions, 'AD_ACCOUNTS_MY_PERMISSIONS_FETCH', {
      dispatch
    });
  };
}
export function fetchAllPermissions(returnPromise = false) {
  return dispatch => wrapReduxAction(AdAccountsData.fetchAllPermissions, 'ALL_PERMISSIONS_FETCH', {
    dispatch,
    returnPromise
  });
}